import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-video-container',
    templateUrl: './video-container.component.html',
    styleUrls: ['./video-container.component.scss'],
    standalone: false
})
export class VideoContainerComponent implements OnInit {
  @Input() videoElement: any;
  @ViewChild('videoContainer', {static: false})container!:ElementRef;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    if(this.videoElement){
      let divElement = this.videoElement;
      let divInlineStyles = divElement.style;
      divInlineStyles.width = '';
      divInlineStyles.height = '';
      var videoElement = this.videoElement.querySelector('video');
      let videoInlineStyles = videoElement.style;
      videoInlineStyles.width= '100%';
      videoInlineStyles.height = '';
      videoInlineStyles.maxHeight= '700px';
      videoInlineStyles.maxWidth= '700px';
      videoInlineStyles.objectFit= 'cover';
      videoInlineStyles.aspectRatio= '16 / 9';
      videoInlineStyles.borderRadius= '10px';
      videoInlineStyles.border= 'solid 1px violet';
      this.container.nativeElement.appendChild(this.videoElement);
    }
  }

}
